import type { FC } from "react"

import { ChevronDownIcon } from "@radix-ui/react-icons"

import styles from "./CompanyWideToggleDropdown.module.scss"

type Props = {
	flagId: string
	isEnabled: boolean
	isOpen: boolean
	onToggleOpen: (flagId: string) => void
	onSelect: (flagId: string, enabled: boolean) => void
}

const PILL_CONFIG = {
	enabled: { className: styles.pillEnabled, label: "会社全体設定" },
	perSalon: { className: styles.pillPerSalon, label: "店舗個別設定" },
}

const getPillConfig = (isEnabled: boolean) => {
	if (isEnabled) return PILL_CONFIG.enabled
	return PILL_CONFIG.perSalon
}

const getDropdownItemClassName = (isActive: boolean): string => {
	const classes = [styles.dropdownItem]
	if (isActive) classes.push(styles.dropdownItemActive)
	return classes.join(" ")
}

const CompanyWideToggleDropdown: FC<Props> = ({
	flagId,
	isEnabled,
	isOpen,
	onToggleOpen,
	onSelect,
}) => {
	const pill = getPillConfig(isEnabled)

	return (
		<div className={styles.dropdownContainer}>
			<button
				className={pill.className}
				onClick={(e) => {
					e.stopPropagation()
					onToggleOpen(flagId)
				}}
			>
				<span>{pill.label}</span>
				<ChevronDownIcon width={12} height={12} />
			</button>
			{isOpen && (
				<div className={styles.dropdownMenu}>
					<button
						className={getDropdownItemClassName(isEnabled)}
						onClick={(e) => {
							e.stopPropagation()
							onSelect(flagId, true)
						}}
					>
						会社全体設定
					</button>
					<button
						className={getDropdownItemClassName(!isEnabled)}
						onClick={(e) => {
							e.stopPropagation()
							onSelect(flagId, false)
						}}
					>
						店舗個別設定
					</button>
				</div>
			)}
		</div>
	)
}

export default CompanyWideToggleDropdown
